var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-checkBox"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._l((_vm.data),function(item,index){return _c('p',{key:index,class:{ bg: _vm.value.code === item.code },on:{"click":function($event){return _vm.change(item)}}},[_vm._v(" "+_vm._s(item.value)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }